import { uriRoot } from 'configs';

export const ROOT = `/accounts`;
export const MODULE = 'ACCOUNTS';
